<template>
  <base-detail
    v-bind:title="title"
    v-bind:rootId="rootId"
    v-bind:rootColumn="rootColumn"
    v-bind:schemaName="'transaction'"
    v-bind:headers="headers"
    v-bind:entity="entity"
    v-bind:lookups="lookups"
    v-on:main-save="main - save"
    v-on:on-parrent-load="on - parrent - load"
  >
    <template v-slot="{ entity, loadRows }">
      <form
        v-on:submit.prevent="save(entity, loadRows)"
        class="input-group mb-3 detail-add-form"
      >
        <div
          class="detail-add-form__field detail-add-form__contact detail-add-form__field--floating"
          :class="{ 'detail-add-form__field--filled': !!entity.contactId }"
        >
          <label class="detail-add-form__label">{{
            $filters.localize('tableColumns.common.contact_fullName')
          }}</label>
          <select
            :disabled="entity.contactId"
            class="form-control detail-add-form__control"
            v-model="entity.contactId"
            required
          >
            <option value="" disabled selected>
              {{ $filters.localize('tableColumns.common.contact_fullName') }}
            </option>
            <option
              v-for="option in contacts"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.fullName }}
            </option>
          </select>
        </div>
        <div
          class="detail-add-form__field detail-add-form__amount detail-add-form__field--floating"
          :class="{ 'detail-add-form__field--filled': entity.amount !== null && entity.amount !== '' }"
        >
          <label class="detail-add-form__label">{{
            $filters.localize('tableColumns.transaction.amount')
          }}</label>
          <input
            class="form-control detail-add-form__control"
            type="number"
            v-model="entity.amount"
            required
          />
        </div>
        <div
          class="detail-add-form__field detail-add-form__reason detail-add-form__field--floating"
          :class="{ 'detail-add-form__field--filled': !!entity.reason }"
        >
          <label class="detail-add-form__label">{{
            $filters.localize('tableColumns.common.reason')
          }}</label>
          <input
            class="form-control detail-add-form__control"
            type="text"
            v-model="entity.reason"
            list="reason"
            required
          />
        </div>
        <datalist id="reason">
          <option
            v-for="reason in lookups.reason"
            :value="reason"
            :key="reason"
          >
            {{ reason }}
          </option>
        </datalist>
        <div class="detail-add-form__action">
          <button
            :disabled="!enabled || entity.amount == 0"
            class="btn btn-primary detail-add-form__submit"
            type="submit"
          >
            {{ entity.amount > 0 ? "Нарахувати" : "Списати" }}
          </button>
        </div>
      </form>
    </template>
  </base-detail>
</template>

<script>
import BaseDetail from "@/components/Sections/BaseDetail.vue";
export default {
  name: "TransactionsDetail",
  components: { BaseDetail },
  emits: ["on-parrent-load", "main-save"],
  props: {
    rootId: { type: String, require: true },
    rootColumn: { type: String, require: true },
    contactId: { type: String, require: true },
    enabled: { type: Boolean },
  },
  methods: {
    async save(data, loadRows) {
      try {
        const result = await this.$store.dispatch("add", {
          table: "transaction",
          body: JSON.parse(JSON.stringify(data)),
        });

        if (!result.data.id) {
          await loadRows.call();
          this.getBalance();
          this.loadLookups();
          this.$toast.success("Успішно оновлено.");
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
        console.log(error);
      }
    },

    loadLookups() {
      if (this.entity.contactId) {
        this.$store
          .dispatch("getFilter", {
            table: "contact",
            body: { id: this.entity.contactId, rootColumn: "Id" },
          })
          .then((response) => {
            this.lookups.contacts = response.data.data;
          });
      } else {
        this.$store
          .dispatch("section", { table: "contact" })
          .then((response) => {
            this.lookups.contacts = response.data.data;
          });
      }
    },
    getBalance() {
      if (this.entity.contactId) {
        this.$store
          .dispatch("get", {
            table: "transaction",
            method: "balance?contactId=" + this.entity.contactId,
          })
          .then((response) => {
            this.balance = response.data.data;
          });
      }
    },
  },
  computed: {
    title: {
      get() {
        return "Баланс: " + this.balance;
      },
    },
    contacts: {
      get() {
        if (this.entity.contactId) return [...this.lookups.contacts];
        else
          return [...this.lookups.contacts].filter(
            (x) => x.id == this.entity.contactId
          );
      },
    },
  },
  watch: {
    contactId: function (newVal) {
      this.entity.contactId = newVal;
      this.getBalance();
    },
  },
  mounted() {
    this.entity.contactId = this.contactId;
    if (this.contactId !== this.rootId) this.entity.activityId = this.rootId;
    this.loadLookups();
    this.getBalance();
  },
  data() {
    return {
      lookups: {
        contacts: [],
        reason: [
          "Оплата товару",
          "Скасування замовлення",
          "Виплата за накладеним платежем",
          "Повернення товару",
        ],
      },
      balance: 0,
      entity: {
        amount: 0,
        activityId: null,
        contactId: null,
        reason: "",
      },
      headers: [
        {
          field: "createdOn",
          name: this.$filters.localize("main.createdOn"),
          sort: true,
          isDate: true,
        },
        {
          field: "createdBy.fullName",
          name: "Контакт",
          router: { id: "contactId", name: "ContactPage" },
        },
        {
          field: "activity.number",
          name: "Замовлення",
          sort: true,
          router: { id: "activityId", name: "OrderPage" },
        },
        { field: "type.name", name: "Операція", sort: true },
        {
          field: "amount",
          name: this.$filters.localize("main.countTitle"),
          sort: true,
        },
        { field: "reason", name: "Причина" },
      ],
    };
  },
};
</script>

<style scoped>
.detail-add-form {
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0;
  position: relative;
  z-index: 20;
  width: 100%;
}

.detail-add-form__field {
  flex: 1 1 0;
  min-width: 0;
  height: 36px;
  min-height: 36px;
  position: relative;
}

.detail-add-form__field + .detail-add-form__field,
.detail-add-form__action {
  margin-left: -1px;
}

.detail-add-form__field:focus-within,
.detail-add-form__control:focus {
  z-index: 2;
}

.detail-add-form__label {
  margin: 0;
  color: #7b8794;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
}

.detail-add-form__field--floating .detail-add-form__label {
  position: absolute;
  top: 50%;
  left: 12px;
  z-index: 3;
  max-width: calc(100% - 24px);
  overflow: hidden;
  transform: translateY(-50%);
  transition: top 0.14s ease, transform 0.14s ease, font-size 0.14s ease, color 0.14s ease;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-add-form__field--floating:focus-within .detail-add-form__label,
.detail-add-form__field--floating.detail-add-form__field--filled .detail-add-form__label {
  top: 6px;
  transform: none;
  color: #4f7fa7;
  font-size: 0.58rem;
  text-transform: uppercase;
}

.detail-add-form__control {
  width: 100%;
  height: 36px;
  min-height: 36px;
  border-color: #ced4da;
  border-radius: 0;
  position: relative;
}

.detail-add-form__field--floating .form-control.detail-add-form__control {
  padding: 14px 12px 2px;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control {
  color: transparent;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control option {
  color: #495057;
}

.detail-add-form__contact,
.detail-add-form__reason {
  min-width: 180px;
}

.detail-add-form__amount {
  min-width: 120px;
}

.detail-add-form__contact .detail-add-form__control {
  border-radius: 0.25rem 0 0 0.25rem;
}

.detail-add-form__action {
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
}

.detail-add-form__submit {
  height: 36px;
  min-height: 36px;
  padding-inline: 1rem;
  white-space: nowrap;
  border-radius: 0 0.25rem 0.25rem 0;
}

@media (max-width: 576px) {
  .detail-add-form {
    gap: 0.5rem;
  }

  .detail-add-form__field,
  .detail-add-form__action,
  .detail-add-form__submit,
  .detail-add-form__control {
    flex-basis: 100%;
    width: 100%;
    margin-left: 0;
    border-radius: 0.25rem;
  }
}
</style>

